import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M6.425 21q-.575 0-1.112-.4t-.713-.975q-.625-2.1-1.025-3.637a53 53 0 0 1-.638-2.7 23 23 0 0 1-.337-2.063q-.1-.9-.1-1.725 0-2.3 1.6-3.9T8 4h5q.674-.9 1.713-1.45A4.8 4.8 0 0 1 17 2q.625 0 1.063.438a1.45 1.45 0 0 1 .4 1.362q-.039.15-.088.275-.101.275-.187.55a4 4 0 0 0-.138.6L20.325 7.5H21.5q.424 0 .712.287.288.288.288.713v5.25a.93.93 0 0 1-.187.575 1.13 1.13 0 0 1-.513.375l-2.125.7-1.25 4.175q-.2.65-.725 1.038-.525.387-1.2.387h-2q-.825 0-1.412-.587A1.93 1.93 0 0 1 12.5 19h-2q0 .824-.588 1.413A1.93 1.93 0 0 1 8.5 21zm.075-2h2v-2h6v2h2l1.55-5.15 2.45-.825V9.5h-1L16 6q0-.5.063-.975.062-.475.187-.925a3.2 3.2 0 0 0-1.275.688q-.55.487-.8 1.212H8Q6.55 6 5.525 7.025A3.37 3.37 0 0 0 4.5 9.5q0 1.025.525 3.512Q5.55 15.502 6.5 19m10-8q.424 0 .712-.287A.97.97 0 0 0 17.5 10a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16.5 9a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.713.288.287.713.287m-4-2q.424 0 .713-.287A.97.97 0 0 0 13.5 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12.5 7h-3a.97.97 0 0 0-.713.287A.97.97 0 0 0 8.5 8q0 .424.287.713Q9.076 9 9.5 9z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }